<template>
    <div>
        <HeaderBg :img="img" :title="$t('adminNews.title')" />
        <Alert 
            v-if="alertToggle == true"
            :acceptedDelete="acceptedDeleteNews" 
            :messege="$t('adminNews.confirmDelete')"
        />
        <header class="admin_content_header">
            <div class="filter">
                <!-- <select>
                    <option value="" selected disabled>المدينة</option>
                </select> -->
            </div>
            <div class="search">
                <!-- <input type="text" placeholder="البحث برقم الفرع"> -->
            </div>
            <router-link to="/admin/news/add-news">{{$t('adminNews.addNews')}}</router-link>
            
        </header>
        <RequestSpinner v-if="loadingRequest == true" />
        <div class="main_table" v-if="loadingRequest == false">
            <table width="100%">
                <thead>
                    <tr>
                        <th>{{$t('adminNews.name')}}</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="news in news" :key="news.id">
                        <td> {{news.translation[0].name}} </td>

                        <td>
                            <div class="block actions">
                                <div class="delete" @click="() => deleteData(news.id)">
                                    <b-icon icon="trash" aria-hidden="true"></b-icon>
                                </div>
                                <div class="edit" @click="() => editNews(news.id)">
                                    <img src="../../../assets/images/editLogo.svg" alt="">
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <div class="pagination mt-5" v-if="cities.length >= 1">
            <b-pagination-nav align="center" :link-gen="linkGen" :number-of-pages="pages" use-router v-model="currentPage"></b-pagination-nav>
        </div> -->
    </div>
</template>
<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import RequestSpinner from '../../global/loadingSpinners/RequestSpinner';
import store from "@/store/index.js";
import Request from '../../../services/Request';
import Alert from '../../global/Alert/Alert';

export default {
    name: 'News',
    components: {HeaderBg, RequestSpinner, Alert},
    data(){
        return{
            loadingRequest: true,
            img: require('../../../assets/images/saleWhite.svg'),
            news: [],

            deleteID: '',
            alertToggle: false,

             // pagination
            apiParams: '',
            currentPage: 1,
            pages: 1,
        }
    },
    mounted(){
        this.getNews();
    },
    methods:{
        getNews(){
            Request.fetch('admin/news', this.apiParams , {
                limit: store.state.limit
            })
            .then((response) => {
                this.news = response.data.data
                this.loadingRequest = false;
                this.pages = Math.ceil(response.data.total / store.state.limit) 
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        editNews(id){
            this.$router.push(`/admin/news/add-news/${id}`)
        },
        deleteData(id){
            this.deleteID = id;
            this.alertToggle = true;
        },
        acceptedDeleteNews(){
            Request.delete('admin/news',this.deleteID)
            .then( () => {
                this.getNews();
            })
        },

        // pagination function
        linkGen(pageNum) {
            return pageNum === 1 ? '?' : `?page=${pageNum}`   
        },
    },
    watch: {
        // pagination
        currentPage: function(val) {
            if(val === 1){
                this.apiParams = '';
                this.getNews();
            } else{
                this.apiParams = `?page=${val}`;
                this.getNews();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.saveBtn{
    margin-top: 0;
    display: block;
    &:hover{
        color: #FFF;
    }
}
.actions{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .delete,
    .edit{
        width: 40px;
        height: 34px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #FF002B;
        cursor: pointer;
        svg{
            color: #FFF;
            font-size: 25px;
        }
    }
    .edit{
        background-color: #78A28F;
        margin-inline-start: 10px;
    }
}
</style>